import filterHelper from './filterHelpers';
// Because this is only used by lokijs dynamicViews (as opposed to a paged database get),
// most of this is dependent on the ActiveRecord context boundary which is passed in via
// the contextualInfo parameter on fromHNode() below.
export default {
    getFilter,
    fromHNode,
    getUriComponent,
    getMql,
    getJavaScriptFilter
};

function fromHNode(hNode, contextualInfo) {
    // At this time (8/7/2023) namespace:relation _should_ always be hardcoded to identity:user
    // technically, there is no reason, but practically, we don't see any reason not to.
    const { namespace = 'identity', relation = 'user' } = hNode;
    const foreignKey = contextualInfo?.limitedUserContext?._id;
    return getFilter(namespace, relation, foreignKey);
}

function getFilter(namespace, relation, foreignKey) {
    return {
        namespace,
        relation,
        foreignKey
    };
}

function getMql(filters) {
    if (filters.byCurrentUser == null) return;
    const { namespace, relation, foreignKey } = filters.byCurrentUser;
    return { [`${namespace}:${relation}._id`]: foreignKey };
}

function getUriComponent(filters) {
    const filter = filters['byCurrentUser'];
    let foreignIdPath = `["${filter.namespace}:${filter.relation}._id"]`;
    return `searchProperties=${encodeURIComponent(foreignIdPath)}&searchTerm=${encodeURIComponent(
        filter.foreignKey
    )}&exact=true`;
}

function getJavaScriptFilter(filter) {
    const { namespace, relation, foreignKey } = filter;
    const propertyName = `${namespace}:${relation}._id`;
    const value = foreignKey;
    return filterHelper.basicFilterToJavaScript({ propertyName, op: '$eq', value });
}
